export default class IntegrationService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }

    sendForSignature(entityId, enquiryId, additionalRecipients, code, orderFormVersion) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/integration/sendforsignature/`, {entityId, enquiryId, additionalRecipients, code, orderFormVersion}); 
    }   

    sendTradeFormForSignature(entityId, enquiryId, additionalRecipients, code) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/integration/sendtradeformforsignature/`, {entityId, enquiryId, additionalRecipients, code}); 
    }       

    getMazdaServiceHistory(mazdaToken, orgName, chassisNo) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/integration/GetMazdaServiceHistory/`, {mazdaToken, orgName, chassisNo}); 
    }           

    getMazdaRecallHistory(mazdaToken, orgName, chassisNo) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/integration/GetMazdaRecallHistory/`, {mazdaToken, orgName, chassisNo}); 
    }           
  }


// WEBPACK FOOTER //
// ./client/app/common/services/integration.service.js